module.exports = __webpack_public_path__ + "media/Shva_i.c1039aa5.mp3";